export const MESSAGE_DURATION_IMPORTANT = 6;
